module.exports = __webpack_public_path__ + "static/media/select-arrow.16a90407.svg";